export default __webpack_public_path__ + "static/tab6Img-a42a1e0978aeaa7dbaef1a66bd585b6f.png";